<template>
    <v-data-table
        :headers="headers"
        :items="items"
        sort-desc
        calculate-widths
        fixed-header
        class="settings-dt mail-dt"
        hide-default-footer
        height="calc(100vh - 48px)"
        :loading="loading"
        :footer-props="{'items-per-page-options': [-1]}"
        :items-per-page="-1"
    >
        <template v-slot:top>
            <update-form
              v-model="dialog"
              :item="item"
              :init-item="initItem"
              :game-types="gameTypes"
              :mail-items="entityMailItems"
              :refresh="load"
              @update-item="onUpdateItem"
            />
        </template>

        <template v-slot:header.action="{ item }">
            <div style="width: 28px" class="float-right">
                <v-icon @click="load()">mdi-refresh</v-icon>
            </div>
        </template>

        <template v-slot:item.action="{ item }">
            <div style="width: 25px" class="float-right">
                <v-icon small @click="edit(item)">mdi-cog-outline</v-icon>
            </div>
        </template>

        <template v-slot:item.row_num="{ item }">
            <span class="row_num"></span>
        </template>

    </v-data-table>
</template>

<script>
    import { cloneDeep } from 'lodash'
    import { API } from '@/utils/api'

    export default {
        name: 'EntityOptions',
        components: {
            UpdateForm: () => import('@/components/settings/entity/UpdateForm.vue'),
        },
        data: () => ({
            headers: [
                { text: '#', value: 'row_num', sortable: false },
                { text: 'Entity', value: 'entity' },
                { text: 'Host', value: 'host' },
                { text: 'entity_id', value: 'entity_id' },
                { text: '', value: 'action', sortable: false },
            ],
            dialog: false,
            initItem: {
                settings: {}
            },
            item: {
                settings: {}
            },
            newItem: {
                settings: {}
            },
            items: [],
            gameTypes: [],
            allMailItems: [],
            loading: false,
        }),
        computed: {
            entityMailItems() {
                if (!this.item?.entity_id) return []
                return this.allMailItems.filter((m) => m.entity_id === this.item.entity_id)
            },
        },
        mounted () {
            this.load()
        },
        methods: {
            edit (item) {
                this.dialog = true
                this.initItem = cloneDeep(item)
                this.item = cloneDeep(item)
            },
            onUpdateItem (updatedItem) {
                this.item = updatedItem
            },
            load () {
                this.loading = true
                return Promise.all([
                    API.call('/settings/entity/list.json', {}),
                    API.call('/mail/settings/list.json', { statuses: ['active'] }),
                ]).then(([entityResp, mailResp]) => {
                    this.items = entityResp.data.entity_settings
                    this.gameTypes = [...entityResp.data.game_types]
                    this.allMailItems = mailResp.data ?? []
                }).finally(() => {
                    this.loading = false
                })
            },
        }
    }
</script>

<style scoped>
    .settings-dt .v-data-table__wrapper {
        display: flex;
    }

    .settings-dt .v-select {
        flex-grow: 1;
    }

    .mail-dt.v-data-table td,
    .mail-dt.v-data-table th {
        padding: 0 8px !important;
    }

    .mail-dt.v-data-table td {
        height: 32px !important;
    }

    .settings-dt tr:not(.report-filter-row) {
        counter-increment: row-num;
    }

    .settings-dt tr td:first-child .row_num::before {
        content: counter(row-num) ". ";
    }
</style>
